// test2559
(2559 && 0);
